// Hero.jsx
import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import "../styles.css";
import Services from "./Services";
import CoreValues from "./CoreValues";

function Hero() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [showImages, setShowImages] = useState(false);
  const [showImages2, setShowImages2] = useState(false);


  // 🧠 جلب البيانات من الـ backend
  useEffect(() => {
    fetch("https://test-env2.triples-sa.com/api/get_content.php")
      .then((res) => res.json())
      .then((json) => {
        setData(json);
        setLoading(false);
      })
      .catch((err) => {
        console.error("خطأ في جلب البيانات:", err);
        setLoading(false);
      });
  }, []);

  // 🧩 استخراج البيانات
  const hero = data?.hero || {};
  const about = data?.about || {};
  const origin = data?.origin || {};
  const mission = data?.mission || {};
  const vision = data?.vision || {};
  const portfolio = data?.portfolio || {};
  const portfolio2 = data?.portfolio2 || {};

  // 🖼️ إعداد الصور كلها بنفس نظام fullHeroImg
  const BASE_URL = "https://test-env2.triples-sa.com/";

  // 🔹 الهيرو
  const heroImg = hero.image || "/uploads/hero.png";
  const fullHeroImg = `${BASE_URL}${heroImg}`;

  // 🔹 نشأة الشركة
  const originImg = origin.image || "/uploads/origin.png";
  const fullOriginImg = `${BASE_URL}${originImg}`;

  // 🔹 الرسالة (لو عندها أيقونة أو صورة)
  const missionIcon = mission.icon || "fa-scroll";

  // 🔹 الرؤية
  const visionImg = vision.image || "/uploads/vision.jpg";
  const fullVisionImg = `${BASE_URL}${visionImg}`;

  // 🔹 صور البورتفوليو
const portfolioImages = Object.keys(portfolio)
  // نجيب كل المفاتيح اللي تبدأ بكلمة images
  .filter((key) => key.startsWith("images"))
  // نرجع المسار الكامل لكل صورة
  .map((key) => `${BASE_URL}${portfolio[key]}`)
  // نتأكد إن الصورة فعلاً موجودة (مش undefined أو فاضية)
  .filter((path) => path && path.trim() !== "");
const portfolio2Images = Object.keys(portfolio2)
  .filter((key) => key.startsWith("images"))
  .map((key) => `${BASE_URL}${portfolio2[key]}`)
  .filter((path) => path && path.trim() !== "");

  // 🔹 العناوين والنصوص
  const heroTitle = hero.title || "مرحبًا بك في متجرنا";
  const heroSubtitle = hero.subtitle || "أفضل المنتجات بأفضل الأسعار";

  const card1 = {
    icon: hero.card_1_icon || "fa-laptop",
    title: hero.card_1_title || "الكترونيات",
  };
  const card2 = {
    icon: hero.card_2_icon || "fa-shield-halved",
    title: hero.card_2_title || "امانة",
  };
  const card3 = {
    icon: hero.card_3_icon || "fa-couch",
    title: hero.card_3_title || "أساس منزلي",
  };

  const aboutTitle = about.title || "من نحن";
  const aboutText =
    about.text || "نحن متجر إلكتروني يقدم أحدث المنتجات بأعلى جودة.";

  const originTitle = origin.title || "نشأة الشركة";
  const originText = origin.text || "";

  const missionTitle = mission.title || "الرسالة";
  const missionText = mission.text || "";

  const visionTitle = vision.title || "الرؤية";
  const visionText = vision.text || "";

  const portfolioTitle = portfolio.title || "بعض منتجاتنا";

  // ✅ Services data
  const getValue = (section, field) => {
    if (!data || !data[section]) return "";
    return data[section][field] || "";
  };
// 📦 قسم img_words
const imgWords = data?.img_words || {};
const imgTitle = imgWords.title || "عنوان افتراضي";
const imgText = imgWords.text || "نص افتراضي تجريبي";

  const servicesTitle = getValue("services", "title");
  const servicesText = getValue("services", "text");
  let servicesItems = [];
  try {
    servicesItems = JSON.parse(getValue("services", "items") || "[]");
  } catch {
    servicesItems = [];
  }

  // ✅ دالة الأنيميشن
  const addAnimation = () => {
    const scrollers = document.querySelectorAll(".scroller");
    scrollers.forEach((scroller) => {
      if (scroller.dataset.animated) return;
      scroller.setAttribute("data-animated", "true");
      const inner = scroller.querySelector(".scroller__inner");
      if (!inner) return;
      const content = Array.from(inner.children);
      content.forEach((item) => {
        const clone = item.cloneNode(true);
        clone.setAttribute("aria-hidden", "true");
        inner.appendChild(clone);
      });
    });
  };

  // ✅ تشغيل الأنيميشن
  useEffect(() => {
    const interval = setInterval(() => {
      const scrollers = document.querySelectorAll(".scroller");
      if (scrollers.length > 0) {
        addAnimation();
        clearInterval(interval);
      }
    }, 300);
    return () => clearInterval(interval);
  }, []);
  
  return (
    <section className="hero">
      {/* صورة الهيرو */}
      <div className="hero_img">
      <div className="img_words">
  <h1>{imgTitle}</h1>
  <h1>{imgText}</h1>
      </div>
      <img
        src={fullHeroImg}
        alt="Hero Section"
        className="hero-image"
      />

        {/* الكروت */}
        <div className="cards">
          {[card1, card2, card3].map((card, i) => (
            <motion.div
              key={i}
              className="card"
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, delay: i * 0.2 }}
              viewport={{ once: true }}
            >
              <i className={`fa-solid ${card.icon}`}></i>
              <h1>{card.title}</h1>
            </motion.div>
          ))}
        </div>
      </div>

      {/* قسم من نحن */}
      <div id="about" className="hero__content">
        <motion.h1
          className="hero__title"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 1 }}
          viewport={{ once: true }}
        >
          {aboutTitle}
        </motion.h1>
        <motion.p
          className="hero__subtitle"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          transition={{ duration: 1, delay: 0.2 }}
          viewport={{ once: true }}
        >
          {aboutText}
        </motion.p>
      </div>

      {/* نشأة الشركة */}
      <motion.h1
        className="hero__title"
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 1 }}
        viewport={{ once: true }}
      >
        {originTitle}
      </motion.h1>
      <div id="origin" className="starting__company">
        <motion.div
          className="image"
          initial={{ opacity: 0, x: -50 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 1 }}
          viewport={{ once: true }}
        >
          <img src={fullOriginImg} alt="Origin" />
        </motion.div>
        <motion.div
          className="right__content"
          initial={{ opacity: 0, x: 50 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 1 }}
          viewport={{ once: true }}
        >
          <p>{originText}</p>
        </motion.div>
      </div>

      {/* الرسالة */}
      <section id="mission" className="mission__section">
        <motion.div
          className="mission__card"
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 1 }}
          viewport={{ once: true }}
        >
          <h1 className="mission__title">
            <i className={`fa-solid ${missionIcon}`}></i> {missionTitle}
          </h1>
          <p className="mission__text">{missionText}</p>
        </motion.div>
      </section>

      {/* الرؤية */}
      <motion.h1
        className="hero__title"
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 1 }}
        viewport={{ once: true }}
      >
        {visionTitle}
      </motion.h1>
      <div id="vision" className="vision__section">
        <motion.div
          className="vision__image"
          initial={{ opacity: 0, x: -50 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 1 }}
          viewport={{ once: true }}
        >
          <img src={fullVisionImg} alt="Vision" />
        </motion.div>
        <motion.div
          className="vision__content"
          initial={{ opacity: 0, x: 50 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 1 }}
          viewport={{ once: true }}
        >
          <p>{visionText}</p>
        </motion.div>
      </div>

{/* ✅ Portfolio Section 1 */}
<div id="portfolio " className="portfolio">
  <div style={{display : "flex" , justifyContent : "center" , padding :  "15px"}}>
      <button
    onClick={() => setShowImages(!showImages)}
    className="show_more"
  >
    <h2>{portfolioTitle || "بعض منتجاتنا"}</h2>
    <i className="fa-solid fa-info"></i>
  </button>
  </div>


  {showImages && (
    <div className="imges">
      {portfolioImages.length > 0 ? (
        portfolioImages.map((img, i) => (
          <img key={i} src={img} alt={`Portfolio ${i}`} />
        ))
      ) : (
        <p>لا توجد صور متاحة</p>
      )}
    </div>
  )}
</div>

{/* ✅ Portfolio Section 2 (نسخة مستقلة بنفس أسلوب القسم الأول) */}
<div id="portfolio2" className="portfolio">
    <div style={{display : "flex" , justifyContent : "center" , padding :  "15px"}}>

  <button
    onClick={() => setShowImages2(!showImages2)}
    className="show_more"
  >
    <h2>{"منتجاتنا الجديدة"}</h2>
    <i className="fa-solid fa-box"></i>
  </button>
  </div>
  {showImages2 && (
    <div className="imges">
      {portfolio2Images.length > 0 ? (
        portfolio2Images.map((img, i) => (
          <img key={i} src={img} alt={`Portfolio2 ${i}`} />
        ))
      ) : (
        <p>لا توجد صور متاحة</p>
      )}
    </div>
  )}
</div>



      <section id="values" className="values__section">


<Services />
<CoreValues />
  
          <div className="hero__buttons scroller">
          <marquee></marquee>
          <div className="tag-list scroller__inner">
: (
    <>
      {/* fallback الصور القديمة لو مفيش حاجة في الداتا */}
            <img src="./img/WhatsApp Image 2025-10-01 at 8.17.49 PM (1).jpeg" alt="" />
            <img src="./img/WhatsApp Image 2025-10-01 at 8.17.49 PM (2).jpeg" alt="" />
            <img src="./img/WhatsApp Image 2025-10-01 at 8.17.49 PM (4).jpeg" alt="" />
            <img src="./img/WhatsApp Image 2025-10-01 at 8.17.49 PM (5).jpeg" alt="" />
            <img src="./img/WhatsApp Image 2025-10-01 at 8.17.49 PM.jpeg" alt="" />
            <img src="./img/WhatsApp Image 2025-10-01 at 8.17.50 PM (1).jpeg" alt="" />
            <img src="./img/WhatsApp Image 2025-10-01 at 8.17.50 PM (2).jpeg" alt="" />
            <img src="./img/WhatsApp Image 2025-10-01 at 8.17.50 PM (3).jpeg" alt="" />
            <img src="./img/WhatsApp Image 2025-10-01 at 8.17.51 PM (4).jpeg" alt="" />
            <img src="./img/WhatsApp Image 2025-10-01 at 8.17.50 PM (5).jpeg" alt="" />
            <img src="./img/WhatsApp Image 2025-10-01 at 8.17.50 PM.jpeg" alt="" />
            <img src="./img/WhatsApp Image 2025-10-01 at 8.17.51 PM (1).jpeg" alt="" />
            <img src="./img/WhatsApp Image 2025-10-01 at 8.17.52 PM (2).jpeg" alt="" />
            <img src="./img/WhatsApp Image 2025-10-01 at 8.17.51 PM (3).jpeg" alt="" />
            <img src="./img/WhatsApp Image 2025-10-01 at 8.17.51 PM (4).jpeg" alt="" />
            <img src="./img/WhatsApp Image 2025-10-01 at 8.17.52 PM (5).jpeg" alt="" />
            <img src="./img/WhatsApp Image 2025-10-01 at 8.17.52 PM.jpeg" alt="" />
    </>
  )
</div>

        </div>
</section>
      {/* Contact Section */}
      <div id="contact" className="contact-section" style={{ padding: "25px", display: "flex", gap: "2rem", marginTop: "4rem" }}>
        <div className="contact-form" style={{ flex: 1 }}>
          <h2 style={{ textAlign: "center" }}>تواصل معنا</h2>
          <form style={{ display: "flex", flexDirection: "column", gap: "1rem" }}>
            <input type="text" placeholder="الاسم" style={{ padding: "10px", borderRadius: "8px", border: "1px solid #ccc" }} />
            <input type="email" placeholder="البريد الإلكتروني" style={{ padding: "10px", borderRadius: "8px", border: "1px solid #ccc" }} />
            <textarea placeholder="الرسالة" rows="5" style={{ padding: "10px", borderRadius: "8px", border: "1px solid #ccc" }}></textarea>
            <button type="submit" style={{ padding: "12px", borderRadius: "8px", background: "#007bff", color: "white", border: "none", cursor: "pointer" }}>
              إرسال
            </button>
          </form>
        </div>

        <div className="contact-map" style={{ flex: 1, display: "flex", justifyContent: "center", alignItems: "center" }}>
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d14491.665173449273!2d46.754708!3d24.764059!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3e2f01fd27994775%3A0x377847732d124330!2sSACO!5e0!3m2!1sen!2ssa!4v1759930514355!5m2!1sen!2ssa"
            width="400"
            height="400"
            style={{ border: 0, borderRadius: "12px" }}
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          />
        </div>
      </div>

      <div className="footer">
        <a href="mailto:triples@triples-as.com" className="footer__link">
          triples@triples-as.com
        </a>
        <a href="https://wa.me/966544505550" target="_blank" rel="noopener noreferrer" className="footer__link">
          966544505550
        </a>
        <div className="footer__address">
          الرياض - طريق الملك عبدالله
        </div>
      </div>
    </section>
  );
}


export default Hero;

// import React, { useContext } from "react";
// import { GlobalContext } from "../GlobalContext";

// const Hero = () => {
//   const { content, loading } = useContext(GlobalContext);

//   if (loading) return <p>جارِ التحميل...</p>;

//   const heroData = content.hero || {};
//   const title = heroData.title || "عنوان افتراضي";
//   const subtitle = heroData.subtitle || "نص تجريبي";
//   const image = heroData.image || "/default-hero.png";

//   return (
//     <section className="hero">
//       <div className="hero-content">
//         <h1>{title}</h1>
//         <p>{subtitle}</p>
//       </div>
//       <img src={image} alt="Hero" />
//     </section>
//   );
// };

// export default Hero;